(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kolabloom-navigation"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('kolabloom-navigation'))customElements.define('kolabloom-navigation',class extends HTMLElement{
 connectedCallback(){requestAnimationFrame(()=>this.init());}
 init(){if(this.ready)return;const dialog=this.querySelector('dialog'),opener=this.querySelector('[data-nav-open]');if(!dialog||!opener)return;this.ready=true;
 const close=()=>dialog.close();
 opener.addEventListener('click',()=>{dialog.showModal();opener.setAttribute('aria-expanded','true');document.documentElement.classList.add('kbn-locked');});
 this.querySelector('[data-nav-close]').addEventListener('click',close);
 dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)close();}});
 dialog.querySelectorAll('a').forEach(a=>a.addEventListener('click',close));
 dialog.addEventListener('close',()=>{opener.setAttribute('aria-expanded','false');document.documentElement.classList.remove('kbn-locked');opener.focus();});
 }
 disconnectedCallback(){if(this.querySelector('dialog')?.open)document.documentElement.classList.remove('kbn-locked');}
});
  } catch(e) { console.error(e); }
})();

})();
